<style>
    .panel-group .panel-heading {
        border: 1px solid lightgray !important;
        padding: 0;
    }
    .panel-body{
        padding-left: 0px;
        padding-right: 0px;
        border-top: 0px !important;
    }
</style>

<div class="row candidate-compare-container" *ngIf="!loadingFlag">
    <div class="row mb-2">
        <div class="col-xs-12 d-flex justify-content-end">
            <button class="btn btn-primary mr-5" (click)="togglePanels()">{{togglePanelsLabel}}</button>
        </div>
    </div>
    <!-- Comparison header -->
    <div class="col-xs-12 sticky-header">
        <div class="candidate-compare panel-body">
            <!-- Job Header -->
            <div [ngClass]="panelBootStrapColumnWidthClass">
                <div class="pricing-package-inner">
                    <div class="package-content">
                        <div class="package-price" style="padding-left: 5px; padding-right: 5px;">
                            <div class="currency text-overflow-ellipsis" [textContent]="jobDetails.jobCompany" tooltip="{{jobDetails.jobCompany}}" placement="bottom"></div>
                        </div>
                    </div>
                    <div class="package-header">
                        <h3 [textContent]="jobDetails.jobTitle" class="text-overflow-ellipsis pt-0 px-5 pb-5" style="line-height: normal" tooltip="{{jobDetails.jobTitle}}" placement="bottom"></h3>
                    </div>
                </div>
            </div>

            <!-- Candidates Header -->
            <ng-container *ngFor="let candidate of comparisonData; let i = index">
            <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                <div class="pricing-package-inner">
                    <div class="package-content">
                        <div class="package-price">
                        </div>
                    </div>
                    <div class="package-header">
                        <h3 [textContent]="candidate.candidateName" class="text-overflow-ellipsis pt-0 px-5 pb-5" style="line-height: normal" tooltip="{{candidate.candidateName}}" placement="bottom"></h3>
                    </div>
                </div>
            </div>
            </ng-container>
        </div>
    </div>

    <accordion [closeOthers]="false">
        <accordion-group class="col-xs-12 main-job-match-accordion" [isOpen]="isJobMatchPanelOpen">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5 class="d-flex justify-content-between">
                                <span>Job Match</span>
                                <span>
                                    <span class="p-1 mr-4 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg"
                                        tooltip="Job Match Threshold Score"
                                        placement="top-left"
                                        container="body">
                                        {{comparisonData[0].maxJobMatchscore}}
                                    </span>
                                    <i class="fas" style="font-size:13px" [ngClass]="{'fa-chevron-up': isJobMatchPanelOpen, 'fa-chevron-down': !isJobMatchPanelOpen}">
                                    </i>
                                </span>
                            </h5>
                        </ul>
                    </div>

                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul class="candidate-compare-list border-0 text-center" style="position:relative; top:7px;">
                            <span class="p-1"
                                tooltip="Job Match Score"
                                placement="top-left"
                                container="body"
                                [ngClass]="{'candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg': candidate.jobMatchScore >= comparisonData[0].maxJobMatchscore
                                , 'candidate-job-match-card-only-intelligence-score-failure': candidate.jobMatchScore < comparisonData[0].maxJobMatchscore}">
                                {{candidate.jobMatchScore}}
                            </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>

            <accordion class="job-match-accordion" *ngIf="isSuperUserOr4dot5Admin">
                <accordion-group class="col-xs-12 p-0" [isOpen]="true">
                    <!-- Education Compare Data -->
                    <div class="candidate-compare" *ngIf="comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScore !== 0 && comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScore !== null" style="margin-bottom: 1.5rem; padding-bottom: 1.5rem;">
                        <!-- Job Data -->
                        <div class="{{panelBootStrapColumnWidthClass}} text-center">
                            <div style="width:200px" class="text-left m-auto">
                                <b class="d-inline-block" style="width:82px">Education:</b>
                                <span class="p-1 ml-2" *ngIf="comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScore === 0 || comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScore === null">
                                    -
                                </span>
                                <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                    tooltip="Allocated Split %"
                                    placement="top-left"
                                    container="body"
                                    *ngIf="comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScore > 0">
                                    {{comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScore}} %
                                </span>
                            </div>

                            <div style="width:200px" class="text-left mx-auto mt-2">
                                <span class="d-inline-block pl-4" style="width:82px">Matching:</span>
                                <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                    tooltip="Allocated Split %"
                                    placement="top-left"
                                    container="body">
                                    {{comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScoreForMatching}} %
                                </span>
                            </div>
                            <div style="width:200px" class="text-left mx-auto mt-2">
                                <span class="d-inline-block pl-4" style="width:82px">Additional:</span>
                                <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                    tooltip="Calculated %"
                                    placement="top-left"
                                    container="body">
                                    {{comparisonData[1].categoryScoreDTO.educationScoreDTO.totalScoreForAdditionalEducation}} %
                                </span>
                            </div>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                            <div class="p-1" *ngIf="candidate.categoryScoreDTO.educationScoreDTO.candidateScore == 0 || candidate.categoryScoreDTO.educationScoreDTO.candidateScore == null">
                                -
                            </div>
                           <div>
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg"
                                    tooltip="Calculated %"
                                    placement="top-left"
                                    container="body"
                                    *ngIf="candidate.categoryScoreDTO.educationScoreDTO.candidateScore > 0">
                                    {{candidate.categoryScoreDTO.educationScoreDTO.candidateScore}} %
                                </span>
                           </div>
                            <div class="mt-2">
                                <span class=" p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg"
                                    tooltip="Calculated %"
                                    placement="top-left"
                                    container="body">
                                    {{candidate.categoryScoreDTO.educationScoreDTO.candidateScoreForMatching}} %
                                </span>
                            </div>

                            <div class="mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg"
                                    tooltip="Calculated %"
                                    placement="top-left"
                                    container="body">
                                    {{candidate.categoryScoreDTO.educationScoreDTO.totalScoreForAdditionalEducation}} %
                                </span>
                            </div>
                        </div>
                        </ng-container>
                    </div>

                    <!-- Experience Compare Data -->
                    <div class="candidate-compare col-xs-12" *ngIf="comparisonData[1].categoryScoreDTO.experienceScoreDTO.totalScore !== 0 && comparisonData[1].categoryScoreDTO.experienceScoreDTO.totalScore !== null" style="padding-bottom: 0.5rem;">
                        <!-- Job Data -->
                        <div class="{{panelBootStrapColumnWidthClass}} text-center">
                            <div style="width: 200px" class="mx-auto mt-2 text-left">
                                <b class="d-inline-block" style="width:82px">Experience:</b>

                                <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                    tooltip="Allocated Split %"
                                    placement="top-left"
                                    container="body">
                                    {{comparisonData[1].categoryScoreDTO.experienceScoreDTO.totalScore}} %
                                </span>
                            </div>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                            <div style="width:200px" class="mx-auto mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg"
                                    tooltip="Calculated %"
                                    placement="top-left"
                                    container="body">
                                    {{candidate.categoryScoreDTO.experienceScoreDTO.candidateScore}} %
                                </span>
                            </div>
                        </div>
                        </ng-container>
                    </div>

                    <!-- Skills Compare Data -->
                    <div class="candidate-compare col-xs-12" style="margin-bottom: 1.5rem; padding-bottom: 1.5rem;">
                        <!-- Job Data -->
                        <div class="{{panelBootStrapColumnWidthClass}} text-center">
                            <div style="width: 200px" class="text-left mx-auto mt-2">
                                <div class="mt-2">
                                    <b class="d-inline-block" style="width:82px">Skills:</b>
                                    <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                        tooltip="Allocated Split %"
                                        placement="top-left"
                                        container="body">
                                        {{comparisonData[1].categoryScoreDTO.skillScoreDTO.totalScore}} %
                                    </span>
                                </div>
                            </div>
                            <div style="width: 200px" class="text-left mx-auto mt-2">
                                <div class="mt-2">
                                    <span class="d-inline-block pl-4" style="width:82px">Required:</span>
                                    <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                        tooltip="Allocated Split %"
                                        placement="top-left"
                                        container="body">
                                        {{comparisonData[1].categoryScoreDTO.skillScoreDTO.totalRequiredSkillScore}}%
                                    </span>
                                </div>
                            </div>
                            <div style="width: 200px" class="text-left mx-auto mt-2">
                                <div class="mt-2">
                                    <span class="d-inline-block pl-5" style="width:82px">Matching:</span>
                                    <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                        tooltip="Allocated Split %"
                                        placement="top-left"
                                        container="body">
                                        {{comparisonData[1].categoryScoreDTO.skillScoreDTO.noOfTotalRequiredSkills}}
                                    </span>
                                </div>
                                </div>
                            <div style="width: 200px" class="text-left mx-auto mt-2">
                                <div class="mt-2">
                                    <span class="d-inline-block pl-4" style="width:82px">Optional:</span>
                                    <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                        tooltip="Allocated Split %"
                                        placement="top-left"
                                        container="body">
                                        {{comparisonData[1].categoryScoreDTO.skillScoreDTO.totalNonRequiredSkillScore}}%
                                    </span>
                                </div>
                                </div>
                            <div style="width: 200px" class="text-left mx-auto mt-2">
                                <div class="mt-2">
                                    <span class="d-inline-block pl-5" style="width:82px">Matching:</span>
                                    <span class="p-1 ml-2 candidate-job-match-card-only-intelligence-score-success bg-primary"
                                        tooltip="Allocated Split %"
                                        placement="top-left"
                                        container="body">
                                        {{comparisonData[1].categoryScoreDTO.skillScoreDTO.noOfTotalNonRequiredSkills}}
                                    </span>
                                </div>
                        </div>
                    </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                            <div style="width: 200px" class="mx-auto mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg"
                                    tooltip="Calculated %"
                                    placement="top-left"
                                    container="body">
                                    {{candidate.categoryScoreDTO.skillScoreDTO.candidateScore}} %
                                </span>
                            </div>

                            <div style="width: 200px" class="mx-auto mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg">
                                    {{candidate.categoryScoreDTO.skillScoreDTO.candidateRequiredSkillScore}} %
                                </span>
                            </div>

                            <div style="width: 200px" class="mx-auto mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg">
                                    {{candidate.categoryScoreDTO.skillScoreDTO.noOfMatchedRequiredSkills}}
                                </span>
                            </div>

                            <div style="width: 200px" class="mx-auto mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg">
                                    {{candidate.categoryScoreDTO.skillScoreDTO.candidateNonRequiredSkillScore}} %
                                </span>
                            </div>

                            <div style="width: 200px" class="mx-auto mt-2">
                                <span class="p-1 candidate-job-match-card-only-intelligence-score-success job-match-card-green-bg">
                                    {{candidate.categoryScoreDTO.skillScoreDTO.noOfMatchedNonRequiredSkills}}
                                </span>
                            </div>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>

            <!-- Candidate Jobs End Here -->

            <!-- Education -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isEducationPanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Education
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isEducationPanelOpen, 'fa-chevron-down': !isEducationPanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>

                            <!-- Candidates Data -->
                            <ng-container *ngFor="let candidate of comparisonData; let i = index">
                            <div class="{{panelBootStrapColumnWidthClass}} text-center" style="font-size: 0.837em;" *ngIf="i > 0">
                                <ul class="candidate-compare-list border-0">
                                    <li *ngIf="candidate.educationComparisons.length > 0" class="candidate-compare-list-item">
                                        <span *ngIf="candidate.latestEducationDto.candidateDegreeName != null">
                                            <i class="pr-2" [ngClass]="{'fas fa-thumbs-up green': candidate.latestEducationDto.status == 'MATCH',
                                                'fas fa-thumbs-down red': candidate.latestEducationDto.status == 'NOT_MATCH',
                                                'fas fa-plus-circle text-primary': candidate.latestEducationDto.status == 'ADDITIONAL',
                                                'far fa-hourglass text-warning': candidate.latestEducationDto.status == 'ALMOST'}"></i>
                                            {{candidate.latestEducationDto.candidateDegreeName}}
                                            <span> at {{candidate.latestEducationDto.candidateInstituteName}}</span>
                                        </span>
                                        <span *ngIf="candidate.latestEducationDto.candidateDegreeName == null">None</span>
                                    </li>
                                    <li *ngIf="candidate.educationComparisons.length == 0">
                                        No details available.
                                    </li>
                                </ul>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div [ngClass]="panelBootStrapColumnWidthClass">
                            <ul class="candidate-compare-list education-assets">
                                <li *ngFor="let jobDetail of jobDetails.educationDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.jobDegreeType != null">{{jobDetail.jobDegreeType}}</span><span *ngIf="jobDetail.jobDegreeType != null && jobDetail.jobDegreeName != null">: </span><span *ngIf="jobDetail.jobDegreeName != null">{{jobDetail.jobDegreeName}}</span>
                                </li>
                                <li *ngIf="jobDetails.educationDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list education-assets">
                                <li *ngFor="let compareDetail of candidate.educationComparisonsGrouped" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.candidateDegreeName == null">None</span>
                                    <span *ngIf="compareDetail.candidateDegreeName != null" [innerHTML]="compareDetail.text"></span>
                                </li>
                                <li *ngIf="candidate.educationComparisonsGrouped.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>

            <!-- Experience -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isExperiencePanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Experience
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isExperiencePanelOpen, 'fa-chevron-down': !isExperiencePanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>

                            <!-- Candidates Data -->
                            <ng-container *ngFor="let candidate of comparisonData; let i = index">
                            <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                                <ul class="candidate-compare-list border-0" style="font-size: 0.875em;">
                                    <li class="candidate-compare-list-item">
                                        <span>{{candidate.totalExperience}} years</span>
                                    </li>
                                </ul>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div [ngClass]="panelBootStrapColumnWidthClass">
                            <ul class="candidate-compare-list experience-assets">
                                <li *ngFor="let jobDetail of jobDetails.experienceDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.jobMinYear != null">{{jobDetail.jobMinYear}}</span>
                                    <span *ngIf="jobDetail.jobMaxYear != null">
                                        <span *ngIf="jobDetail.jobMinYear != null"> - </span>{{jobDetail.jobMaxYear}}
                                    </span>
                                    <span *ngIf="jobDetail.jobMinYear != null || jobDetail.jobMaxYear != null"> Years</span>
                                </li>
                                <li *ngIf="jobDetails.experienceDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list experience-assets">
                                <li *ngFor="let compareDetail of candidate.experienceComparisons" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.candidateExp != null && compareDetail.candidateExp != 0">{{compareDetail.candidateExp | convertDurationInYears}}</span>
                                    <span>at {{compareDetail.company}}</span>
                                </li>
                                <li *ngIf="candidate.experienceComparisons.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>

            <!-- Technical skills -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isTechnicalSkillsPanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Technical Skills
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isTechnicalSkillsPanelOpen, 'fa-chevron-down': !isTechnicalSkillsPanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>

                            <!-- Candidates Data -->
                            <ng-container *ngFor="let candidate of comparisonData; let i = index">
                            <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                                <ul class="candidate-compare-list border-0 skills-count">
                                    <li>
                                        <span class="skill-count">
                                            <i class="fas fa-thumbs-up green"></i>
                                            <span>
                                                {{candidate.technicalSkillCounts.matched}}
                                            </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="fas fa-thumbs-down red"></i>
                                            <span>{{candidate.technicalSkillCounts.unMatched}} </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="fas fa-plus-circle text-primary"></i>
                                            <span>{{candidate.technicalSkillCounts.additional}} </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="far fa-hourglass text-warning"></i>
                                            <span>{{candidate.technicalSkillCounts.almost}} </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div [ngClass]="panelBootStrapColumnWidthClass">
                            <ul class="candidate-compare-list tech-assets">
                                <li *ngFor="let jobDetail of jobDetails.technicalSkillDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.competency != null">{{jobDetail.competency}}</span>
                                    <sup *ngIf="jobDetail.required" class="text-danger job-profile-skill-required-indicator">*</sup>
                                    <span class="text-dark" *ngIf="jobDetail.experience != null && jobDetail.experience != 0"> {{jobDetail.experience}} years</span>
                                </li>
                                <li *ngIf="jobDetails.technicalSkillDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list tech-assets">
                                <li *ngFor="let compareDetail of candidate.technicalSkillComparisons" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.status == 'MATCH'">
                                        <span>{{compareDetail.candidateExperience}} years</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'NOT_MATCH'">
                                    <span *ngIf="compareDetail.candidateExperience != 0">{{compareDetail.candidateExperience}} years</span><span *ngIf="compareDetail.candidateExperience == 0">No</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ALMOST'">
                                        <span *ngIf="compareDetail.candidateExperience != 0">{{compareDetail.candidateExperience}} years</span><span *ngIf="compareDetail.candidateExperience == 0">Yes</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ADDITIONAL'">
                                        <span>{{compareDetail.competency}}</span><span *ngIf="compareDetail.candidateExperience != 0"> {{compareDetail.candidateExperience}} years</span>
                                    </span>
                                </li>
                                <li *ngIf="candidate.technicalSkillComparisons.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>

            <!-- Operational skills -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isOperationalSkillsPanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Operational Skills
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isOperationalSkillsPanelOpen, 'fa-chevron-down': !isOperationalSkillsPanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>

                            <!-- Candidates Data -->
                            <ng-container *ngFor="let candidate of comparisonData; let i = index">
                            <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                                <ul class="candidate-compare-list border-0 skills-count">
                                    <li>
                                        <span class="skill-count">
                                            <i class="fas fa-thumbs-up green"></i>
                                            <span>
                                                {{candidate.operationalSkillCounts.matched}}
                                            </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="fas fa-thumbs-down red"></i>
                                            <span>{{candidate.operationalSkillCounts.unMatched}} </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="fas fa-plus-circle text-primary"></i>
                                            <span>{{candidate.operationalSkillCounts.additional}} </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="far fa-hourglass text-warning"></i>
                                            <span>{{candidate.operationalSkillCounts.almost}} </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div [ngClass]="panelBootStrapColumnWidthClass">
                            <ul class="candidate-compare-list operational-assets">
                                <li *ngFor="let jobDetail of jobDetails.operationalSkillDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.competency != null">{{jobDetail.competency}}</span>
                                    <span class="text-dark" *ngIf="jobDetail.experience != null && jobDetail.experience != 0"> {{jobDetail.experience}} years</span>
                                </li>
                                <li *ngIf="jobDetails.operationalSkillDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list operational-assets">
                                <li *ngFor="let compareDetail of candidate.operationalSkillComparisons" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.status == 'MATCH'">
                                        <span>{{compareDetail.candidateExperience}} years</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'NOT_MATCH'">
                                    <span *ngIf="compareDetail.candidateExperience != 0">{{compareDetail.candidateExperience}} years</span><span *ngIf="compareDetail.candidateExperience == 0">None</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ALMOST'">
                                        <span *ngIf="compareDetail.candidateExperience != 0">{{compareDetail.candidateExperience}} years</span><span *ngIf="compareDetail.candidateExperience == 0">Yes</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ADDITIONAL'">
                                        <span>{{compareDetail.competency}}</span><span *ngIf="compareDetail.candidateExperience != 0"> {{compareDetail.candidateExperience}} years</span>
                                    </span>
                                </li>
                                <li *ngIf="candidate.operationalSkillComparisons.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>

            <!-- Soft skills -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isSoftSkillsPanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Soft Skills
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isSoftSkillsPanelOpen, 'fa-chevron-down': !isSoftSkillsPanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>

                            <!-- Candidates Data -->
                            <ng-container *ngFor="let candidate of comparisonData; let i = index">
                            <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                                <ul class="candidate-compare-list border-0 skills-count">
                                    <li>
                                        <span class="skill-count">
                                            <i class="fas fa-thumbs-up green"></i>
                                            <span>
                                                {{candidate.softSkillCounts.matched}}
                                            </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="fas fa-thumbs-down red"></i>
                                            <span>{{candidate.softSkillCounts.unMatched}} </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="fas fa-plus-circle text-primary"></i>
                                            <span>{{candidate.softSkillCounts.additional}} </span>
                                        </span>
                                        <span class="skill-count">
                                            <i class="far fa-hourglass text-warning"></i>
                                            <span>{{candidate.softSkillCounts.almost}} </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div [ngClass]="panelBootStrapColumnWidthClass">
                            <ul class="candidate-compare-list soft-assets">
                                <li *ngFor="let jobDetail of jobDetails.softSkillDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.competency != null">{{jobDetail.competency}}</span>
                                    <span class="text-dark" *ngIf="jobDetail.experience !== null && jobDetail.experience !== 0"> {{jobDetail.experience}} years</span>
                                </li>
                                <li *ngIf="jobDetails.softSkillDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list soft-assets">
                                <li *ngFor="let compareDetail of candidate.softSkillComparisons" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.status == 'MATCH'">
                                        <span>{{compareDetail.candidateExperience}} years</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'NOT_MATCH'">
                                    <span *ngIf="compareDetail.candidateExperience != 0">{{compareDetail.candidateExperience}} years</span><span *ngIf="compareDetail.candidateExperience == 0">None</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ALMOST'">
                                        <span *ngIf="compareDetail.candidateExperience != 0">{{compareDetail.candidateExperience}} years</span><span *ngIf="compareDetail.candidateExperience == 0">Yes</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ADDITIONAL'">
                                        <span>{{compareDetail.competency}}</span><span *ngIf="compareDetail.candidateExperience != 0"> {{compareDetail.candidateExperience}} years</span>
                                    </span>
                                </li>
                                <li *ngIf="candidate.softSkillComparisons.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>

            <!-- Other skills -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isOtherSkillsPanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Other Skills
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isOtherSkillsPanelOpen, 'fa-chevron-down': !isOtherSkillsPanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>

                            <!-- Candidates Data -->
                            <ng-container *ngFor="let candidate of comparisonData; let i = index">
                            <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                                <ul class="candidate-compare-list border-0 skills-count">
                                    <li>
                                        <span class="skill-count">
                                            <i class="fas fa-plus-circle text-primary"></i>
                                            <span>{{candidate.otherSkillCounts.additional}} </span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div [ngClass]="panelBootStrapColumnWidthClass">
                            <ul class="candidate-compare-list other-assets">
                                <li *ngFor="let jobDetail of jobDetails.otherDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.competency != null">{{jobDetail.competency}}</span>
                                </li>
                                <li *ngIf="jobDetails.otherDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list other-assets">
                                <li *ngFor="let compareDetail of candidate.otherComparisons" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.status == 'MATCH'">
                                        <span *ngIf="compareDetail.candidateExperience == 0">Yes</span>
                                        <span *ngIf="compareDetail.candidateExperience != 0"> {{compareDetail.candidateExperience}} years</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'NOT_MATCH'">
                                    <span>No</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ALMOST'">
                                        <span *ngIf="compareDetail.candidateExperience == 0">Yes</span>
                                        <span *ngIf="compareDetail.candidateExperience != 0"> {{compareDetail.candidateExperience}} years</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ADDITIONAL'">
                                        <span>{{compareDetail.competency}}</span>
                                        <span *ngIf="compareDetail.candidateExperience != 0"> {{compareDetail.candidateExperience}} years</span>
                                    </span>
                                </li>
                                <li *ngIf="candidate.otherComparisons.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>


            <!-- Certifications -->
            <accordion class="job-match-accordion">
                <accordion-group class="col-xs-12 p-0" [isOpen]="isCertificationsPanelOpen">
                    <div accordion-heading>
                        <div class="candidate-compare row">
                            <!-- Job Data -->
                            <div class="{{panelBootStrapColumnWidthClass}} text-center">
                                <ul class="candidate-compare-list border-0">
                                    <h5>Certifications
                                        <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isCertificationsPanelOpen, 'fa-chevron-down': !isCertificationsPanelOpen}">
                                        </i>
                                    </h5>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="candidate-compare">
                        <!-- Job Data -->
                        <div class="{{panelBootStrapColumnWidthClass}} text-center">
                            <ul class="candidate-compare-list certification-assets">
                                <li *ngFor="let jobDetail of jobDetails.certificationDetails" class="candidate-compare-list-item">
                                    <span *ngIf="jobDetail.Name != null">{{jobDetail.Name}}</span>
                                </li>
                                <li *ngIf="jobDetails.certificationDetails.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>

                        <!-- Candidates Data -->
                        <ng-container *ngFor="let candidate of comparisonData; let i = index">
                        <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                            <ul class="candidate-compare-list certification-assets">
                                <li *ngFor="let compareDetail of candidate.certificationComparisons" class="candidate-compare-list-item"
                                    [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                                    <span *ngIf="compareDetail.status == 'MATCH'">
                                        <span *ngIf="compareDetail.certificationName != null">{{compareDetail.certificationName}}<span *ngIf="compareDetail.candidateInstituteName != null"> from {{compareDetail.candidateInstituteName}}</span></span>
                                        <span *ngIf="compareDetail.certificationName == null">Yes</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'NOT_MATCH'">
                                    <span>None</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ALMOST'">
                                        <span *ngIf="compareDetail.certificationName != null">{{compareDetail.certificationName}}<span *ngIf="compareDetail.candidateInstituteName != null"> from {{compareDetail.candidateInstituteName}}</span></span>
                                        <span *ngIf="compareDetail.certificationName == null">Yes</span>
                                    </span>
                                    <span *ngIf="compareDetail.status == 'ADDITIONAL'">
                                        <span>{{compareDetail.certificationName}}<span *ngIf="compareDetail.candidateInstituteName != null"> from {{compareDetail.candidateInstituteName}}</span></span>
                                    </span>
                                </li>
                                <li *ngIf="candidate.certificationComparisons.length == 0">
                                    No details available.
                                </li>
                            </ul>
                        </div>
                        </ng-container>
                    </div>
                </accordion-group>
            </accordion>
        </accordion-group>
    </accordion>


<!-- Salary-->
    <div role="tablist" class="panel-group">
        <div class="col-xs-12 panel panel-open">
            <div role="tab" aria-selected="true" class="panel-heading">
                <h4 class="panel-title">
                    <a role="button" class="accordion-toggle">
                        <span>
                            <div class="candidate-compare row">
                                <!-- Job Data -->
                                <div [ngClass]="panelBootStrapColumnWidthClass">
                                    <ul class="candidate-compare-list border-0">
                                        <h5>Salary
                                            <span *ngIf="!isComparisonEmpty(jobDetails.salaryDetails)" style="font-size:13px">
                                                ({{jobDetails.salaryDetails.jobSalary}})
                                            </span>
                                            <span *ngIf="isComparisonEmpty(jobDetails.salaryDetails)" style="font-size:13px">
                                                (None Specified)
                                            </span>
                                        </h5>
                                    </ul>
                                </div>

                                <!-- Candidate data -->
                                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                                <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                                    <ul class="candidate-compare-list border-0 text-center">
                                        <li *ngIf="!isComparisonEmpty(candidate.salaryComparisons)" class="candidate-compare-list-item">
                                            <span [ngClass]="{'text-warning': candidate.salaryComparisons.status == 'NOT_MATCH', 'green': candidate.salaryComparisons.status !== 'NOT_MATCH' }">
                                                {{candidate.salaryComparisons.candidateSalary}}
                                            </span>
                                        </li>
                                        <span *ngIf="isComparisonEmpty(candidate.salaryComparisons)">
                                            __
                                        </span>
                                    </ul>
                                </div>
                                </ng-container>
                            </div>
                        </span>
                    </a>
                </h4>
            </div>
        </div>
    </div>

    <!-- Sponsorships -->
    <accordion>
        <accordion-group class="col-xs-12" [isOpen]="isSponsorshipsPanelOpen">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5>Sponsorships
                                <span *ngIf="jobDetails.sponsorshipDetails.length == 0" style="font-size: 13px;">
                                    (None Specified)
                                </span>
                                <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isSponsorshipsPanelOpen, 'fa-chevron-down': !isSponsorshipsPanelOpen}">
                                </i>
                            </h5>
                        </ul>
                    </div>

                    <!-- Candidate data -->
                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul class="candidate-compare-list border-0 text-center">
                            <span *ngIf="candidate.sponsorshipComparisons.length > 0 || candidate.sponsorshipComparisonDTO"  class="fas fa-check green panel-title-candidate-info">
                            </span>
                            <span *ngIf="candidate.sponsorshipComparisons.length == 0 && !candidate.sponsorshipComparisonDTO">
                                __
                            </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="candidate-compare">
                <!-- Job Data -->
                <div [ngClass]="panelBootStrapColumnWidthClass">
                    <ul class="candidate-compare-list sponsorship-assets">
                        <li *ngFor="let sponsorship of jobDetails.sponsorshipDetails" class="candidate-compare-list-item">
                            <span *ngIf="sponsorship.sponsorshipName != null">{{sponsorship.sponsorshipName}}</span>
                        </li>
                        <li *ngIf="jobDetails.sponsorshipDetails.length == 0">
                            No details available.
                        </li>
                    </ul>
                </div>

                <!-- Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                    <ul class="candidate-compare-list sponsorship-assets">
                        <li *ngFor="let compareDetail of candidate.sponsorshipComparisons" class="candidate-compare-list-item"
                            [ngClass]="{'has-feature': compareDetail.status == 'MATCH','has-nofeature': compareDetail.status == 'NOT_MATCH','additional': compareDetail.status == 'ADDITIONAL','almost': compareDetail.status == 'ALMOST'}">
                            <span *ngIf="compareDetail.status == 'MATCH'">
                                <span>Yes</span>
                            </span>
                            <span *ngIf="compareDetail.status == 'NOT_MATCH'">
                               <span>No</span>
                            </span>
                            <span *ngIf="compareDetail.status == 'ALMOST'">
                                <span>Yes</span>
                            </span>
                            <span *ngIf="compareDetail.status == 'ADDITIONAL'">
                                <span>{{compareDetail.sponsorshipName}}</span>
                            </span>
                        </li>
                        <li *ngIf="candidate.sponsorshipComparisons.length == 0 && !candidate.sponsorshipComparisonDTO">
                            No details available.
                        </li>
                        <textarea *ngIf="candidate.sponsorshipComparisonDTO" style="resize:none" class="form-control"
                            rows="2"
                            style="width: 100%; height: 49px;"
                            readonly
                            [textContent]="candidate.sponsorshipComparisonDTO.note">
                        </textarea>
                    </ul>
                </div>
                </ng-container>
            </div>
        </accordion-group>
    </accordion>

    <!-- Relocation -->
    <accordion>
        <accordion-group class="col-xs-12" [isOpen]="isRelocationPanelOpen">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5>Relocation
                                <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isRelocationPanelOpen, 'fa-chevron-down': !isRelocationPanelOpen}">
                                </i>
                            </h5>
                        </ul>
                    </div>

                    <!-- Candidates Data -->
                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul class="candidate-compare-list skills-count border-0 text-center">
                                <span *ngIf="!isComparisonEmpty(candidate.relocationComparisons) && candidate.relocationComparisons.status == 'MATCH'
                                    || candidate.relocationComparisons.status == 'NOT_MATCH'
                                    || candidate.relocationComparisons.status == 'ALMOST'
                                    || candidate.relocationComparisons.status == 'ADDITIONAL'"
                                    class="panel-title-candidate-info">
                                    <span class="green" *ngIf="candidate.relocationComparisons.willingToRelocate=='YES'">Yes</span>
                                    <span class="text-danger" *ngIf="candidate.relocationComparisons.willingToRelocate=='NO'">No</span>
                                    <span class="text-warning" *ngIf="candidate.relocationComparisons.willingToRelocate=='NOT_APPLICABLE'">Not Applicable</span>
                                </span>
                            <span *ngIf="isComparisonEmpty(candidate.relocationComparisons)">
                                __
                            </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="candidate-compare">
                <!-- Job Data -->
                <div [ngClass]="panelBootStrapColumnWidthClass">
                    <ul class="candidate-compare-lists">
                    </ul>
                </div>

                <!-- Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                    <ul class="text-center">
                        <textarea *ngIf="candidate.relocationComparisonDTO" style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="candidate.relocationComparisonDTO.note">
                        </textarea>
                        <span *ngIf="!candidate.relocationComparisonDTO">
                            No details available.
                        </span>
                    </ul>
                </div>
                </ng-container>
            </div>
        </accordion-group>
    </accordion>

    <!-- Additional Information -->
    <accordion>
        <accordion-group class="col-xs-12" [isOpen]="isAdditionalInformationPanelOpen">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5>Additional Information
                                <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': isAdditionalInformationPanelOpen, 'fa-chevron-down': !isAdditionalInformationPanelOpen}">
                                </i>
                            </h5>
                        </ul>
                    </div>

                    <!-- Candidate data -->
                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul class="candidate-compare-list border-0 text-center">
                            <span *ngIf="candidate.additionalInfoNoteDTO" class="fas fa-check green panel-title-candidate-info">
                            </span>
                            <span *ngIf="!candidate.additionalInfoNoteDTO">
                                __
                            </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="candidate-compare">
                <!-- Job Data -->
                <div [ngClass]="panelBootStrapColumnWidthClass">
                    <ul class="candidate-compare-lists">
                    </ul>
                </div>

                <!-- Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                    <ul class="text-center">
                        <textarea *ngIf="candidate.additionalInfoNoteDTO" style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="candidate.additionalInfoNoteDTO.note">
                        </textarea>
                        <span *ngIf="!candidate.additionalInfoNoteDTO">
                            No details available.
                        </span>
                    </ul>
                </div>
                </ng-container>
            </div>
        </accordion-group>
    </accordion>

    <!-- Workflow comparison -->
    <accordion *ngFor="let workflowStep of workflowSteps">
        <!-- Recruiter Screening -->
        <accordion-group class="col-xs-12" [isOpen]="workflowStep.isOpen" *ngIf="workflowStep.step === 'Recruiter Screening' || workflowStep.step === 'Phone Screen' || workflowStep.step === 'Interview'">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5>
                                <span *ngIf="workflowStep.step === 'Recruiter Screening'">Recruiter Screening</span>
                                <span *ngIf="workflowStep.step === 'Phone Screen'">Phone Screen</span>
                                <span *ngIf="workflowStep.step === 'Interview'">Interview</span>
                                <i class="fas pull-right" style="font-size:13px" [ngClass]="{'fa-chevron-up': workflowStep.isOpen, 'fa-chevron-down': !workflowStep.isOpen}">
                                </i>
                            </h5>
                        </ul>
                    </div>

                    <!-- Candidate data -->
                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul *ngIf="workflowStep.step === 'Recruiter Screening'" class="candidate-compare-list border-0 text-center" >
                            <span *ngIf="candidate.workflowStepsComparisons.recruiterScreeningComparisons.state" class="panel-title-candidate-info">
                                {{candidate.workflowStepsComparisons.recruiterScreeningComparisons.state}}
                            </span>
                            <span *ngIf="!candidate.workflowStepsComparisons.recruiterScreeningComparisons.state">
                                __
                            </span>
                        </ul>

                        <ul *ngIf="workflowStep.step === 'Phone Screen'" class="candidate-compare-list border-0 text-center" >
                            <span *ngIf="candidate.workflowStepsComparisons.phoneScreenComparisons.state" class="panel-title-candidate-info">{{candidate.workflowStepsComparisons.phoneScreenComparisons.state}}</span>
                            <span *ngIf="!candidate.workflowStepsComparisons.phoneScreenComparisons.state">
                                __
                            </span>
                        </ul>
                        <ul *ngIf="workflowStep.step === 'Interview'" class="candidate-compare-list border-0 text-center">
                            <span *ngIf="candidate.workflowStepsComparisons.interviewComparisons.state" class="panel-title-candidate-info">{{candidate.workflowStepsComparisons.interviewComparisons.state}}</span>
                            <span *ngIf="!candidate.workflowStepsComparisons.interviewComparisons.state">
                                __
                            </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="candidate-compare">
                <!-- Job Data -->
                <div [ngClass]="panelBootStrapColumnWidthClass">
                    <span class='pl-5'>Overall Comment</span>
                </div>

                <!-- Recruiter Screening Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0" [hidden]="workflowStep.step !== 'Recruiter Screening'">
                    <span *ngIf="!candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks">
                        No Details Available
                    </span>

                    <div style="border: 1px solid lightgray" class="row text-left p-4" *ngFor="let feedback of candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks; let fi = index">
                        <div class="col-xs-3">Rating : </div>
                        <div class="col-xs-9 disable-element">
                            <div class="overall-qn-slider" id="overall-qn-slider__{{candidate.jobMatchId}}_{{fi}}"></div>
                        </div>

                        <div class="col-xs-3"></div>
                        <div class="col-xs-9 text-center">
                            <span id="overall-qn-rating__{{candidate.jobMatchId}}_{{fi}}" [textContent]="feedback.rating" style="position: relative; top:5px;"></span>
                        </div>

                        <div class="col-xs-12" *ngIf="feedback.ratingGivenBy != null">
                            <span class="recorded-by"> Recorded by {{feedback.ratingGivenBy}} on {{feedback.dateTime | fourDotFiveTimeStampFormatPipe }}</span>
                        </div>

                        <div class="col-xs-12 pt-3">
                            <textarea style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="feedback.comment">
                            </textarea>
                        </div>
                        <div class="col-xs-12 pt-3" *ngIf="feedback.externalComment">
                            <textarea style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="feedback.externalComment">
                            </textarea>
                        </div>
                        <div class="col-xs-12">
                            <a class="emerald pt-2" (click)="viewFeedback('Screening', 'Screening', candidate.candidateId, candidate.jobMatchId)">View Feedback</a>
                        </div>
                    </div>
                </div>
                </ng-container>

                <!-- Phone Screen Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0" [hidden]="workflowStep.step !== 'Phone Screen'">
                    <span *ngIf="!candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks">
                        No Details Available
                    </span>

                    <div style="border: 1px solid lightgray" class="row text-left p-4" *ngFor="let feedback of candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks; let fi = index">
                        <div class="col-xs-3">Rating : </div>
                        <div class="col-xs-9 disable-element">
                            <div class="overall-qn-slider_ps" id="overall-qn-slider__{{candidate.jobMatchId}}_{{fi}}_ps"></div>
                        </div>

                        <div class="col-xs-3"></div>
                        <div class="col-xs-9 text-center">
                            <span id="overall-qn-rating__{{candidate.jobMatchId}}_{{fi}}_ps" [textContent]="feedback.rating" style="position: relative; top:5px;"></span>
                        </div>

                        <div class="col-xs-12" *ngIf="feedback.ratingGivenBy != null">
                            <span class="recorded-by"> Recorded by {{feedback.ratingGivenBy}} on {{feedback.dateTime | fourDotFiveTimeStampFormatPipe }}</span>
                        </div>

                        <div class="col-xs-12 pt-3">
                            <textarea style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="feedback.comment">
                            </textarea>
                        </div>
                        <div class="col-xs-12 pt-3" *ngIf="feedback.externalComment">
                            <textarea style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="feedback.externalComment">
                            </textarea>
                        </div>
                        <div class="col-xs-12">
                            <a class="emerald pt-2" (click)="viewFeedback('PhoneScreen', 'PhoneScreen', candidate.candidateId, candidate.jobMatchId)">View Feedback</a>
                        </div>
                    </div>
                </div>
                </ng-container>

                <!-- Interview Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0" [hidden]="workflowStep.step !== 'Interview'">
                    <span *ngIf="!candidate.workflowStepsComparisons.interviewComparisons.feedbacks">
                        No Details Available
                    </span>

                    <div style="border: 1px solid lightgray" class="row text-left p-4" *ngFor="let feedback of candidate.workflowStepsComparisons.interviewComparisons.feedbacks; let fi = index">
                        <div class="col-xs-3">Rating : </div>
                        <div class="col-xs-9 disable-element">
                            <div class="overall-qn-slider_in" id="overall-qn-slider__{{candidate.jobMatchId}}_{{fi}}_in"></div>
                        </div>

                        <div class="col-xs-3"></div>
                        <div class="col-xs-9 text-center">
                            <span id="overall-qn-rating__{{candidate.jobMatchId}}_{{fi}}_in" [textContent]="feedback.rating" style="position: relative; top:5px;"></span>
                        </div>

                        <div class="col-xs-12" *ngIf="feedback.ratingGivenBy != null">
                            <span class="recorded-by"> Recorded by {{feedback.ratingGivenBy}} on {{feedback.dateTime | fourDotFiveTimeStampFormatPipe }}</span>
                        </div>

                        <div class="col-xs-12 pt-3">
                            <textarea style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="feedback.comment">
                            </textarea>
                        </div>
                        <div class="col-xs-12 pt-3" *ngIf="feedback.externalComment">
                            <textarea style="resize:none" class="form-control"
                                rows="2"
                                style="width: 100%; height: 49px;"
                                readonly
                                [textContent]="feedback.externalComment">
                            </textarea>
                        </div>
                        <div class="col-xs-12">
                            <a class="emerald pt-2" (click)="viewFeedback('Interview', 'Interview', candidate.candidateId, candidate.jobMatchId)">View Feedback</a>
                        </div>
                    </div>
                </div>
                </ng-container>
            </div>
        </accordion-group>

        <!-- Technical Assessment -->
        <accordion-group class="col-xs-12" [isOpen]="workflowStep.isOpen" *ngIf="workflowStep.step === 'Tech Assessment'">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5 class="d-flex justify-content-between">
                                <span>Technical Assessment</span>
                                <span>
                                    <span *ngIf="comparisonData[0].maxTechAssessmentScore"
                                        tooltip="Threshold Score"
                                        placement="top-left"
                                        container="body"
                                        class="mr-4 candidate-job-match-card-tech-score-success job-match-card-green-bg">
                                        {{comparisonData[0].maxTechAssessmentScore}}
                                    </span>
                                    <i class="fas" style="font-size:13px" [ngClass]="{'fa-chevron-up': workflowStep.isOpen, 'fa-chevron-down': !workflowStep.isOpen}">
                                    </i>
                                </span>
                            </h5>
                        </ul>
                    </div>

                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul class="candidate-compare-list border-0 text-center" style="position:relative; top:7px;">
                            <span *ngIf="candidate.workflowStepsComparisons.techAssessmentComparisons.reportUrl"
                                    tooltip="Technical Assessment Score"
                                    placement="top-left"
                                    container="body"
                                    [ngClass]="{'candidate-job-match-card-tech-score-success job-match-card-green-bg': candidate.workflowStepsComparisons.techAssessmentComparisons.score >= comparisonData[0].maxTechAssessmentScore,'candidate-job-match-card-tech-score-failure': candidate.workflowStepsComparisons.techAssessmentComparisons.score < comparisonData[0].maxTechAssessmentScore }">
                                    {{candidate.workflowStepsComparisons.techAssessmentComparisons.score}}
                                </span>
                                <span *ngIf="!candidate.workflowStepsComparisons.techAssessmentComparisons.reportUrl">
                                    __
                                </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="candidate-compare">
                <!-- Job Data -->
                <div [ngClass]="panelBootStrapColumnWidthClass">
                </div>

                <!-- Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                    <span *ngIf="candidate.workflowStepsComparisons.techAssessmentComparisons.reportUrl" class="emerald pointer" (click)="getReport(candidate.jobMatchId, 'Technical', candidate.workflowStepsComparisons.techAssessmentComparisons.sectionalReport, candidate.workflowStepsComparisons.techAssessmentComparisons.reportUrl, candidate.workflowStepsComparisons.techAssessmentComparisons.testInvitationId)">View Report</span>
                    <span *ngIf="!candidate.workflowStepsComparisons.techAssessmentComparisons.reportUrl">
                        No Details Available
                    </span>
                </div>
                </ng-container>
            </div>
        </accordion-group>

    <!-- Value Assessment -->
        <accordion-group class="col-xs-12" [isOpen]="workflowStep.isOpen" *ngIf="workflowStep.step === 'Value Assessment'">
            <div accordion-heading>
                <div class="candidate-compare row">
                    <!-- Job Data -->
                    <div [ngClass]="panelBootStrapColumnWidthClass">
                        <ul class="candidate-compare-list border-0">
                            <h5 class="d-flex justify-content-between">
                                <span>Value Assessment</span>
                                <span>
                                    <span *ngIf="comparisonData[0].maxValueAssessmentScore"
                                        tooltip="Threshold Score"
                                        placement="top-left"
                                        container="body"
                                        class="mr-4 candidate-job-match-card-tech-score-success job-match-card-green-bg">
                                        {{comparisonData[0].maxValueAssessmentScore}}
                                    </span>
                                    <i class="fas" style="font-size:13px" [ngClass]="{'fa-chevron-up': workflowStep.isOpen, 'fa-chevron-down': !workflowStep.isOpen}">
                                    </i>
                                </span>
                            </h5>
                        </ul>
                    </div>

                    <ng-container *ngFor="let candidate of comparisonData; let i = index">
                    <div [ngClass]="panelBootStrapColumnWidthClass" *ngIf="i > 0">
                        <ul class="candidate-compare-list border-0 text-center" style="position:relative; top:7px;">
                            <span *ngIf="candidate.workflowStepsComparisons.valueAssessmentComparisons.reportUrl"
                                    tooltip="Value Assessment Score"
                                    placement="top-left"
                                    container="body"
                                    [ngClass]="{'candidate-job-match-card-tech-score-success job-match-card-green-bg': candidate.workflowStepsComparisons.valueAssessmentComparisons.reportUrl >= comparisonData[0].maxValueAssessmentScore,'candidate-job-match-card-tech-score-failure': candidate.workflowStepsComparisons.valueAssessmentComparisons.score < comparisonData[0].maxValueAssessmentScore }">
                                    {{candidate.workflowStepsComparisons.valueAssessmentComparisons.score}}
                                </span>
                                <span *ngIf="!candidate.workflowStepsComparisons.valueAssessmentComparisons.reportUrl">
                                    __
                                </span>
                        </ul>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="candidate-compare">
                <!-- Job Data -->
                <div [ngClass]="panelBootStrapColumnWidthClass">
                </div>

                <!-- Candidates Data -->
                <ng-container *ngFor="let candidate of comparisonData; let i = index">
                <div class="{{panelBootStrapColumnWidthClass}} text-center" *ngIf="i > 0">
                    <span *ngIf="candidate.workflowStepsComparisons.valueAssessmentComparisons.reportUrl" class="emerald pointer" (click)="getReport(candidate.jobMatchId, 'Value', candidate.workflowStepsComparisons.valueAssessmentComparisons.sectionalReport, candidate.workflowStepsComparisons.techAssessmentComparisons.reportUrl, candidate.workflowStepsComparisons.valueAssessmentComparisons.testInvitationId)">View Report</span>
                    <span *ngIf="!candidate.workflowStepsComparisons.valueAssessmentComparisons.reportUrl">
                        No Details Available
                    </span>
                </div>
                </ng-container>
            </div>
        </accordion-group>
    </accordion>
</div>
<div class="row skeleton-container" *ngIf="loadingFlag" style="height: 600px">
    <div class="col-xs-12">
        <div class="skeleton-heading width-50 skeleton-loading" style="margin-bottom:15px"></div>
        <div class="d-flex justify-content-between skeleton-container mb-3">
            <div class="skeleton-content skeleton-loading" style="width:30%"></div>
            <div class="skeleton-content skeleton-loading" style="width:30%"></div>
            <div class="skeleton-content skeleton-loading" style="width:30%"></div>
        </div>
        <div class="skeleton-paragraph width-100 skeleton-loading mb-2"></div>
        <div class="skeleton-paragraph width-100 skeleton-loading mb-2"></div>
        <div class="skeleton-paragraph width-75 skeleton-loading mb-2"></div>
        <div class="skeleton-paragraph width-100 skeleton-loading mb-2"></div>
        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
    </div>
</div>
